import React, { useState, useEffect, useRef } from "react";
import { GlobalState } from "contexts/GlobalState";
import { Container, Row, Col } from "react-bootstrap";
import { useLazyQuery } from "@apollo/client";
import _ from "lodash";
import qs from "query-string";

import useSearch from "hooks/useSearch";
import { GET_DEGREES_OPTIONS } from "schemas/program"

import "./style.scss";

export const DegreeFilter = (props) => {
  const [globalSearch, setGlobalSearch] = GlobalState("search");
  const { searchPrograms,writeOurFiltersToUrl } = useSearch();
  const [degreeFilters, setDegreeFilters] = useState([]);
  const firstResults = useRef(true);

  const [getDegreesOptions, { loading: degreesLoading, data: degreesData }] = useLazyQuery(GET_DEGREES_OPTIONS, {
    fetchPolicy: "no-cache",
  });
  useEffect(() => {
    if (!_.isEmpty(globalSearch.filters)) {
      let searchFilters = _.cloneDeep(globalSearch.filters);
      delete searchFilters.degree;
      getDegreesOptions({
        variables: {
          search: searchFilters
        }
      })
    }
  },[globalSearch.filters])

  const sortDegree = (filtersOptions)=>{
  let collection = degreesData.getDegreesOptions;
  const last = collection.length;
  let sortedCollection = _.sortBy(collection, function (item) {
  return filtersOptions.indexOf(item.name) !== -1
  ? filtersOptions.indexOf(item.name) : last;
  });
   return sortedCollection;
  }
  useEffect(() => {
    if(!degreesLoading && degreesData) {
      const filtersOptions = props.twr_filtered.map(filterOption => filterOption.name)  
      let degreeTypes=sortDegree(filtersOptions)
      degreeTypes=degreeTypes.map(degreeOption => degreeOption.name);
      degreeTypes = degreeTypes.filter(degreeType => filtersOptions.includes(degreeType));
      setDegreeFilters(degreeTypes);
      firstResults.current = false;
    }
  },[degreesData])

  const handleClick = (value) => {
    const searchFilters = {
      ...globalSearch.filters,
      isSearch: true
    }  
    if (searchFilters.degree === value) {
      delete searchFilters.degree;
    } else {
      searchFilters.degree = value;
    }
    searchPrograms(searchFilters);
    writeOurFiltersToUrl(searchFilters);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      handleClick(e.target.textContent);
    }
  } 
  
  return (
    <Container className={`degree-filter`}>
      <Row className="all-degrees">
        {degreeFilters?.map((singleFilter) => (
          <Col
            role="checkbox"
            key={singleFilter}
            aria-label={`${singleFilter}, custom checkbox`}
            aria-checked={singleFilter === globalSearch.filters?.degree ? "true" : "false"}
            tabIndex="0"
            sm={4}
            md={2}
            className={`degree${
              singleFilter === globalSearch.filters?.degree ? " selected" : ""
            }`}
            onClick={() => handleClick(singleFilter)}
            onKeyDown={(e) => handleKeyDown(e)}
          >
            {singleFilter}
          </Col>
        ))}
      </Row>
    </Container>
  );
};
